import React from 'react';

const MentionsContent = () => (
  <>
    <h3>1. Éditeur du site</h3>
    <p><strong>Raison sociale :</strong> Mon Impôt Zen</p>
    <p><strong>Forme juridique :</strong> Société par actions simplifiée</p>
    <p><strong>Capital social :</strong> 2.000 €</p>
    <p><strong>Siège social :</strong> 72 B Vieux Chemin de Bergheim 67600 Sélestat</p>
    <p><strong>SIREN :</strong> 991351313</p>
    <p><strong>SIRET :</strong> 99135131300010</p>
    <p><strong>Numéro de TVA intracommunautaire :</strong> FR01991351313</p>
    <p><strong>Email :</strong> contact@monimpotzen.fr</p>

    <h3>2. Hébergeur</h3>
    <p><strong>Nom de l'hébergeur :</strong> Vercel Inc. </p>
    <p><strong>Adresse :</strong> 340 S Lemon Ave #4133 Walnut, CA 91789 États-Unis</p>

    <h3>3. Propriété intellectuelle</h3>
    <p>L'ensemble des contenus présents sur le site Mon Impôt Zen (textes, images, graphismes, logo, icônes, etc.) sont protégés par le droit d'auteur et le droit des marques. Toute reproduction, représentation, modification, publication ou adaptation de tout ou partie des éléments du site est interdite sans autorisation écrite préalable.</p>

    <h3>4. Données personnelles et RGPD</h3>
    <p>Conformément au Règlement Général sur la Protection des Données (RGPD) et à la loi Informatique et Libertés, vous disposez d'un droit d'accès, de rectification, de suppression et de portabilité de vos données personnelles.</p>
    <p><strong>Responsable du traitement :</strong> Mon Impôt Zen</p>
    <p><strong>Finalités du traitement :</strong> Gestion des demandes de contact, exécution des prestations de conseil fiscal, envoi d'informations commerciales (avec consentement).</p>
    <p><strong>Durée de conservation :</strong> Les données sont conservées pendant 5 ans à compter de la fin de la relation contractuelle.</p>
    <p><strong>Destinataires :</strong> Les données ne sont transmises à aucun tiers sans votre accord préalable.</p>
    <p>Pour exercer vos droits, contactez-nous à : contact@monimpotzen.fr</p>

    <h3>5. Cookies</h3>
    <p>Le site Mon Impôt Zen peut utiliser des cookies pour améliorer l'expérience utilisateur et analyser le trafic. Vous pouvez configurer votre navigateur pour refuser les cookies ou être alerté lors de leur envoi.</p>

    <h3>6. Limitation de responsabilité</h3>
    <p>Mon Impôt Zen s'efforce d'assurer l'exactitude des informations diffusées sur ce site, mais ne peut garantir leur exhaustivité ou leur mise à jour en temps réel. L'utilisation des informations présentes sur le site relève de la seule responsabilité de l'utilisateur.</p>
    <p>Mon Impôt Zen ne pourra être tenu responsable des dommages directs ou indirects résultant de l'accès ou de l'utilisation du site.</p>

    <h3>7. Liens hypertextes</h3>
    <p>Le site peut contenir des liens vers d'autres sites internet. Mon Impôt Zen n'exerce aucun contrôle sur ces sites et décline toute responsabilité quant à leur contenu.</p>

    <h3>8. Droit applicable</h3>
    <p>Les présentes mentions légales sont régies par le droit français. Tout litige relatif à l'utilisation du site sera soumis à la compétence exclusive des tribunaux français.</p>

    <p className="cgv-footer">Mon Impôt Zen – contact@monimpotzen.fr – monimpotzen.fr</p>
  </>
);

export default MentionsContent;
